<script>
import icons from 'src/icons';

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const props = {};
    if (this.$slots.default[0].text && icons[this.$slots.default[0].text]) {
      props.icon = this.$slots.default[0].text;
      props.raw = icons[props.icon];
    }
    return props;
  },
};
</script>

<template lang="pug">
figure(:class="[$style.root, disabled && $style.disabled]", v-html="raw", :key="icon", :data-test="`ICON_${icon.toUpperCase()}`")
</template>

<style module lang="sass">
.root
  color: inherit
  background: transparent
  overflow: hidden
  position: relative
  & > svg
    display: block
    fill: currentColor

.disabled
  pointer-events: none
  opacity: 0.5
  cursor: no-drop

</style>
